module.exports = __webpack_public_path__ + "static/media/jest.9fbc20d6.ico";